import * as yup from 'yup';
import { Formulaire, Reservation } from '../entities';
import { schemaReservation } from '.';

export const schemaFormulaire = yup.object<Formulaire>({
    nomEcole: yup.string().required('Ce champ est requis'),
    idCss: yup.number().typeError('Ce champ est requis').required('Ce champ est requis'),
    nomContact: yup.string().required('Ce champ est requis'),
    prenomContact: yup.string().required('Ce champ est requis'),
    courrielContact: yup
        .string()
        .email('Ce champ doit contenir une adresse courriel valide')
        .required('Ce champ est requis'),
    telContact: yup.string().required('Ce champ est requis'),
    nbParticipants: yup
        .number()
        .transform((value, originalValue) => (String(originalValue).trim() === '' ? undefined : value))
        .positive('Le nombre de participants doit être positif')
        .integer('Ce champ doit contenir un nombre')
        .required('Ce champ est requis'),
    groupeAge: yup.string().required('Ce champ est requis'),
    reservations: yup
        .array()
        .test('minCompact', 'Au moins une activité doit être selectionnée', (reservations: Array<Reservation>) => {
            return reservations.reduce(
                (accumulator: boolean, current: Reservation) =>
                    Boolean(current.date || current.activite || accumulator),
                false,
            );
        })
        .min(1, 'Au moins une activité doit être selectionnée')
        .of(schemaReservation)
        .required('Ce champ est requis'),
    posteContact: yup.string(),
    contexte: yup.string(),
    notes: yup.string(),
});
